import { PageHeader } from 'components'
import { MonthlyRotation } from 'page-components'
import { AuthService } from 'utility/services/auth'
import { canCreateMonthlyRotation, isMonthlyRotationCompany } from 'utility/monthly-rotation'

export const MonthlyRotationScreen = () => {
    const user = AuthService.getUser()
    const canCreate = canCreateMonthlyRotation(user)
    return (
        <div>
            <PageHeader header="Monthly Rotation" />
            {canCreate ? (
                <MonthlyRotation />
            ) : (
                <p className="mt-3">
                    {isMonthlyRotationCompany(user)
                        ? 'Only a company admin can create the monthly rotation.'
                        : 'Monthly Rotation is not available for your company.'}
                </p>
            )}
        </div>
    )
}
